var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"b__dropdown__group",attrs:{"right":"","no-caret":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._t("button-content"),_c('x-icon',{staticClass:"violet-600",attrs:{"name":"more_horiz"}})]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }